import React from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip
} from 'reactstrap';
import * as XLSX from 'xlsx';
import { get, map, upperCase } from 'lodash';
import axios from 'axios';
import classnames from 'classnames';
import { toast } from 'react-toastify';
import withRouter from 'react-router-dom/withRouter';
import ModalItensElaborador from './ModalItensElaborador';
import FiltroAvancadoItens from './FiltroAvancadoItens';
import ElaboradoresTab from './ElaboradoresTab';
import PedidosTab from './PedidosTab';
import { API_HOST } from '../../consts';
import RevisoresTab from './RevisoresTab';

class ListaEncomendaCardTabs extends React.Component {
  static defaultProps = {
    pedidos: []
  };

  state = {
    activeTab: 'pedidos',
    itensVinculados: [],
    ordering: null,
    metadata: []
  };

  shouldDisplayDefault(field) {
    const { metadata } = this.state;
    return get(metadata, field);
  }

  fetchMetadata() {
    this.setState({ fetchingMetadata: true });
    return axios
      .get(`${API_HOST}/params/param?model=${this.metadataModels.join('|')}`)
      .then((response) => {
        this.setState({
          metadata: this.mapMetadata(response.data),
          fetchingMetadata: false
        });
      });
  }

  get initialValuesBuscaAvancadaItem() {
    const { pedidoSelecionado } = this.state;

    if (!pedidoSelecionado) {
      return {};
    }

    return {
      matriz_referencia: get(pedidoSelecionado, 'matriz_referencia.id'),
      competencia: get(pedidoSelecionado, 'competencia.id'),
      habilidade: get(pedidoSelecionado, 'habilidade.id')
    };
  }

  get filtroModalItensElaborador() {
    const { selecionado } = this.state;
    return {
      criado_por: get(selecionado, 'usuario_id'),
      pedido: get(selecionado, 'pedido_id')
    };
  }

  get filtroModalItensRevisor() {
    const { selecionado } = this.state;
    return {
      revisado_por: get(selecionado, 'usuario_id'),
      encomenda_id: get(selecionado, 'encomenda_id')
    };
  }

  toggle(tab) {
    this.setState({ activeTab: tab });
  }

  toggleModal(name, extra = {}) {
    const { openModal } = this.state;
    this.setState({ openModal: openModal === name ? null : name, ...extra });
  }

  handleVincularError(error) {
    const status = get(error, 'response.status');
    if (status === 400) {
      const errors = [
        ...get(error, 'response.data.item', []),
        ...get(error, 'response.data.non_field_errors', [])
      ];
      toast.error(
        <ul>
          {errors.map((e) => (
            <li key={e}>{e}</li>
          ))}
        </ul>
      );
    } else {
      toast.error('Ocorreu um erro.');
    }
  }

  vincularItem = (item) => {
    const { pedidoSelecionado } = this.state;
    axios
      .post(`${API_HOST}/encomenda/elaborador_item`, {
        item: item.id,
        pedido: pedidoSelecionado.id
      })
      .then(() => {
        toast.success('Item vinculado com sucesso.');
        const { itensVinculados } = this.state;
        this.setState({ itensVinculados: [...itensVinculados, item.id] });
      })
      .catch((e) => {
        this.handleVincularError(e);
      });
  };

  desvincularItem = (item) => {
    const { pedidoSelecionado } = this.state;
    axios
      .delete(
        `${API_HOST}/encomenda/pedido/${pedidoSelecionado.id}/desvincular`,
        {
          params: {
            item: item.id
          }
        }
      )
      .then(() => {
        toast.success('Item desvinculado com sucesso.');
        const { itensVinculados } = this.state;
        this.setState({
          itensVinculados: itensVinculados.filter((d) => d !== item.id)
        });
      })
      .catch((e) => {
        this.handleVincularError(e);
      });
  };

  handleVincularItens = (pedido) => {
    this.setState({
      pedidoSelecionado: pedido,
      openModal: 'vincularItens'
    });
  };

  filterTable = (list, search) => {
    const { ordering } = this.state;
    if (ordering) {
      const { index, desc } = ordering;
      list.sort((a, b) => {
        if (a[index] > b[index]) {
          return desc ? -1 : 1;
        }
        if (a[index] < b[index]) {
          return desc ? 1 : -1;
        }
        return 0;
      });
    }
    if (search) {
      return list.filter((e) => upperCase(e).includes(upperCase(search)));
    }

    return list;
  };

  handleVerMaisPedido = (row) => {
    const itensElaboradorProps = {
      nome: row.original.nome,
      id: row.original.id,
      filters: {
        elaborador: row.original.id
      }
    };
    this.toggleModal('itensElaborador', { itensElaboradorProps });
  };

  fetchElaboradores = () => {
    const { encomenda } = this.props;
    this.setState({ fetchingData: true });
    axios
      .get(`${API_HOST}/encomenda/itens_por_status/usuario`, {
        params: {
          encomenda
        }
      })
      .then((response) => {
        this.downloadExcel(response.data.usuarios);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  fetchRevisores = () => {
    const { encomenda } = this.props;
    return axios
      .get(`${API_HOST}/encomenda/revisor/tabela_excel`, {
        params: {
          encomenda
        }
      })
      .then((response) => {
        this.setState({
          dataRevisor: response.data.usuarios,
          fetchingData: false
        });
        this.downloadExcelRevisor(response.data.usuarios);
      });
  };

  downloadExcel = (data) => {
    let jsonArray = [];

    data.map((d) => {
      let jsonFormated = {};

      if (JSON.stringify(d.itens) === JSON.stringify([])) {
        jsonFormated = {
          'Nome Elaborador': d.nome,
          'Código do item': 'Não possui itens criados',
          'Status do item': 'Não possui status',
          'Dificuldade Presumida': 'Não possui dificuldade',
          'Data do item': 'Não possui data',
          'Total de itens solicitados': d.quantidade,
          'Total de itens entregue': d.entregues
        };
        jsonArray.push(jsonFormated);
      }
      d.itens.map((it) => {
        jsonFormated = {
          'Nome Elaborador': it.criado_por,
          'Código do item': it.codigo_item,
          'Status do item': it.status,
          'Dificuldade Presumida': it.dificuldade_presumida,
          'Data do item': it.criado_em,
          'Total de itens solicitados': it.quantidade,
          'Total de itens entregue': it.entregues
        };
        jsonArray.push(jsonFormated);
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(jsonArray);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Detalhe itens - Elaboradores'
    );
    XLSX.writeFile(
      workbook,
      `Elaboradores-${get(data, '[0].encomenda_nome')}.xlsx`
    );
  };

  downloadExcelRevisor = (data) => {
    const jsonArray = [];

    data.forEach((d) => {
      const createItem = (
        nome,
        item_id,
        descricao,
        solicitado,
        revisado,
        tipo_revisao
      ) => ({
        'Nome Revisor': nome,
        'Código do item': item_id,
        'Status do item': descricao,
        'Total de revisões solicitadas': solicitado,
        'Total de revisões realizadas': revisado,
        'Tipo de Revisão': tipo_revisao
      });
      if (d.status_item.length === 0) {
        jsonArray.push(
          createItem(
            d.nome,
            'Não houve revisão',
            'Não houve revisão',
            d.solicitado,
            d.revisado,
            'Não houve revisão'
          )
        );
      } else {
        d.status_item.forEach((st) => {
          jsonArray.push(
            createItem(
              st.criado_por,
              st.item_id,
              st.descricao,
              st.quantidade,
              st.revisados,
              st.tipo_revisao
            )
          );
        });
      }
    });

    const workbook = XLSX.utils.book_new();
    const worksheet1 = XLSX.utils.json_to_sheet(jsonArray);

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet1,
      'Detalhe itens - Revisores'
    );

    const worksheet2Data = data.map((d) => ({
      Revisor: d.nome,
      'Total de revisões solicitadas': d.solicitado,
      'Total de revisões realizadas': d.revisado_distinct
    }));

    const worksheet2 = XLSX.utils.json_to_sheet(worksheet2Data);
    XLSX.utils.book_append_sheet(workbook, worksheet2, 'Resumo Revisores');

    XLSX.writeFile(
      workbook,
      `Revisores-${get(data, '[0].encomenda_nome')}.xlsx`
    );
  };

  render() {
    const {
      activeTab,
      itensVinculados,
      openModal,
      itensElaboradorProps,
      dataElaborador,
      dataRevisor
    } = this.state;
    const {
      tabs,
      encomenda,
      pedidos,
      view_revisor_permission,
      view_generate_report_permission,
      labelCompetencia,
      labelHabilidade
    } = this.props;

    return (
      <>
        <div className="card-item card-alone">
          {view_generate_report_permission ? (
            <div style={{ float: 'right', height: 0 }}>
              <button
                id="relatorio-revisor"
                key="3"
                className="btn btn-white mb-3"
                onClick={() => this.fetchRevisores(dataRevisor)}
              >
                <i className="far fa-file-excel" />
                <span style={{ marginLeft: '5px' }}>
                  Gerar relatório de Revisores
                </span>
              </button>
              <button
                id="relatorio-elaborador"
                key="3"
                className="btn btn-white mb-3"
                style={{ marginLeft: '10px' }}
                onClick={() => this.fetchElaboradores(dataElaborador)}
              >
                <i className="far fa-file-excel" />
                <span style={{ marginLeft: '5px' }}>
                  Gerar relatório de Elaboradores
                </span>
              </button>
            </div>
          ) : null}
          <Nav tabs>
            {tabs.find((d) => d === 'pedidos') && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'pedidos' })}
                  onClick={() => this.toggle('pedidos')}
                >
                  Pedidos
                </NavLink>
              </NavItem>
            )}
            {tabs.find((d) => d === 'elaboradores') && (
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === 'elaboradores'
                  })}
                  onClick={() => this.toggle('elaboradores')}
                >
                  Elaboradores
                </NavLink>
              </NavItem>
            )}
            {tabs.find((d) => d === 'revisores') && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'revisores' })}
                  onClick={() => this.toggle('revisores')}
                >
                  Revisores
                </NavLink>
              </NavItem>
            )}
          </Nav>

          <TabContent activeTab={activeTab}>
            {tabs.find((d) => d === 'pedidos') && (
              <TabPane tabId="pedidos">
                <div className="card-body no-radius-top">
                  {map(pedidos, (pedido) => (
                    <PedidosTab
                      key={pedido.id}
                      labelCompetencia={
                        labelCompetencia ||
                        'Competência'
                      }
                      labelHabilidade={
                        labelHabilidade ||
                        'Habilidade'
                      }
                      startCollapsed={view_revisor_permission}
                      pedido={pedido}
                      handleVincularItens={() =>
                        this.handleVincularItens(pedido)
                      }
                      handleVerMais={(row) =>
                        this.handleVerMaisPedido(row, pedido.id)
                      }
                      getItensVinculados={(itens) =>
                        this.setState({ itensVinculados: itens })
                      }
                    />
                  ))}
                </div>
              </TabPane>
            )}
            {tabs.find((d) => d === 'revisores') && (
              <TabPane tabId="revisores">
                <div className="card-body no-radius-top">
                  <RevisoresTab
                    encomenda={encomenda}
                    history={this.props.history}
                    shouldFetchData={activeTab === 'revisores'}
                  />
                </div>
              </TabPane>
            )}
            {tabs.find((d) => d === 'elaboradores') && (
              <TabPane tabId="elaboradores">
                <div className="card-body no-radius-top">
                  <ElaboradoresTab
                    encomenda={encomenda}
                    shouldFetchData={activeTab === 'elaboradores'}
                  />
                </div>
              </TabPane>
            )}
          </TabContent>

          <FiltroAvancadoItens
            isOpen={openModal === 'vincularItens'}
            toggle={() => this.toggleModal('vincularItens')}
            filter={false}
            onResultClick={this.vincularItem}
            checked={itensVinculados}
            initialValues={this.initialValuesBuscaAvancadaItem}
            vincularItem={this.vincularItem}
            desvincularItem={this.desvincularItem}
          />

          <ModalItensElaborador
            isOpen={openModal === 'itensElaborador'}
            toggle={() =>
              this.toggleModal('itensElaborador', { selecionado: null })
            }
            {...itensElaboradorProps}
          />
        </div>
      </>
    );
  }
}

export default withRouter(ListaEncomendaCardTabs);
